import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Community } from '../../../models/identity/community.model';
import { CommunityService } from '../../../services/identity/community.service';

@Directive({
    selector: '[appHideForCommunities]',
    inputs: ['appHideForCommunities'],
})
export class HideForCommunitiesDirective {
    userCommunities: Community[];
    constructor(
        private _templateRef: TemplateRef<any>,
        private _viewContainer: ViewContainerRef,
        private communityService: CommunityService,
    ) {}

    @Input() set appHideForCommunities(notAllowedCommunitiesIds: Array<string>) {
        this.communityService.getMyCommunities().subscribe((userCommunities: Community[]) => {
            this.userCommunities = userCommunities;
            this.changeVisibility(notAllowedCommunitiesIds);
        });
    }

    changeVisibility(notAllowedCommunitiesIds: Array<string>): void {
        // Search if the allowed communities find themselves in the user communities
        const userCommunitiesIds = this.userCommunities.map((userCommunity) => userCommunity.id);
        const shouldShow = userCommunitiesIds.some((userCommunityId) =>
            !notAllowedCommunitiesIds.includes(userCommunityId),
        );

        if (shouldShow) {
            this._viewContainer.createEmbeddedView(this._templateRef);
        } else {
            this._viewContainer.clear();
        }
    }


}
